import { useQuery } from "@tanstack/react-query"
import { useConfigStore } from "@/lib/store/config"
import { getConfig } from "@/lib/api/config"
import { useEffect } from "react"
import { queryKeys } from "@/lib/utils/query"

export const useConfig = () => {
  const { strings, setStrings, getString, getStringWithParameters } =
    useConfigStore()

  const { data, isLoading, error } = useQuery({
    queryKey: queryKeys.config,
    queryFn: getConfig,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  })

  useEffect(() => {
    if (data) {
      setStrings(data)
    }
  }, [data])

  return {
    t: getString,
    tp: getStringWithParameters,
    strings,
    isLoading,
    error,
  }
}
